import type {
  FilterItem,
  PaginationParams,
} from "@components/TableFilters/FiltersPanel/FiltersPanel.types";

export const transformFiltersToPayload = (
  paginationParams: PaginationParams,
  filters: FilterItem[],
) => {
  const payload: Record<string, any> = {
    pageSize: paginationParams.pageSize,
    pageNumber: paginationParams.page,
  };

  filters.forEach(({ field, value }) => {
    payload[field] = [...(payload[field] ?? []), value];
  });

  return payload;
};
